import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaInfoCircle } from 'react-icons/fa';
import * as R from 'ramda';
import * as PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { field as fieldPropType } from 'App/features/ProtocolManager/AddRule/AddRule.proptypes';
import SelectField from 'Shared/form/SelectField';

const propTypes = {
    fields: PropTypes.arrayOf(fieldPropType).isRequired,
};

const defaultProps = {};

function FilterFields({ fields }) {
    const formik = useFormikContext();
    const { values: formikValues } = formik;

    return (
        <SelectField
            fieldName="filterField"
            label={
                <span>
                    Filter Fields
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="patient-fields-tooltip">Fields available for filtering.</Tooltip>}
                    >
                        <FaInfoCircle className="info-icon float-right" />
                    </OverlayTrigger>
                </span>
            }
            options={R.reject((field) => R.path(['conditions', field.label], formikValues), fields)}
            isClearable
        />
    );
}

FilterFields.propTypes = propTypes;
FilterFields.defaultProps = defaultProps;

export default FilterFields;
